import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import {
	useGetQueryMemberStatusListQuery,
	useGetQueryServiceFollowListQuery,
	useGetStaffAllListQuery,
} from '@/api/common';
import { useSelector } from 'react-redux';
import { selectMyInfo } from '@/pages/auth/authSlice';
import {
	TypeOfQueryMemberStatusListEnum,
	TypeOfQueryServiceFollowListEnum,
} from '@/api/enum/common.enum';

interface Prop {
	allEnumList: any;
}
export default function MemberAllSummaryFilterSection(props: Prop) {
	const { allEnumList } = props;
	const { t } = useTranslation();
	const { control } = useFormContext<any>();
	const userInfo = useSelector(selectMyInfo);

	const { data: staffList }: any = useGetStaffAllListQuery(
		userInfo?.currentBranch?.id || '',
		{
			refetchOnMountOrArgChange: true,
			skip: !userInfo?.currentBranch,
		}
	);

	const { data: queryServiceFollowList }: any =
		useGetQueryServiceFollowListQuery(TypeOfQueryServiceFollowListEnum.All, {
			refetchOnMountOrArgChange: true,
		});

	const { data: queryMemberStatusList }: any = useGetQueryMemberStatusListQuery(
		TypeOfQueryMemberStatusListEnum.ALL_MEMBER_SUMMARY,
		{
			refetchOnMountOrArgChange: true,
		}
	);

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid size={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='responsibleCaseWorkerIdList'
					label={t('member.responsibleCaseWorker')}
					options={staffList?.data || []}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='responsibleProgramWorkerIdList'
					label={t('member.responsibleProgramWorker')}
					options={staffList?.data || []}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='responsibleProfessionalStaffIdList'
					label={t('member.responsibleProfessionalStaff')}
					options={staffList?.data || []}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='serviceFollowList'
					label={t('member.serviceFollow')}
					options={(queryServiceFollowList?.data || []).map((item: any) => {
						return {
							...item,
							id: item.code,
							name: item.desc,
						};
					})}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='membershipStateList'
					label={t('member.membershipState')}
					options={(allEnumList?.data.MembershipStateEnum || []).map(
						(item: any) => {
							return {
								...item,
								id: item.code,
								name: item.desc,
							};
						}
					)}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='statusList'
					label={t('member.status')}
					options={(queryMemberStatusList?.data || []).map((item: any) => {
						return {
							...item,
							id: item.code,
							name: item.desc,
						};
					})}
				/>
			</Grid>
		</Grid>
	);
}
